import {flickityLib} from '../lazy_modules';

export class VideoSlider {
    readonly flicktyPromise: ng.IPromise<any>;
             videos: any[];
    private flickity: any;

    constructor(private $element: ng.IAugmentedJQuery,
                private $q: ng.IQService) {
        this.flicktyPromise = !options.handHeld ?
            $q(resolve => loadScripts([flickityLib], resolve)) :
            $q.reject(null);
    }

    $postLink() {
        this.flicktyPromise.then(() => {
            const Flickity = (window as any).Flickity;
            this.flickity  = new Flickity(this.$element[0].firstChild, {
                cellSelector: 'video-slider .video-item',
                prevNextButtons: true,
                wrapAround: true,
                draggable: false,
                resize: false,
                cellAlign: 'left',
                adaptiveHeight: true,
                setGallerySize: false,
                pageDots: false
            });

            this.hideButtons();
        });
    }

    private hideButtons() {
        if (this.flickity.slideableWidth <= this.flickity.slider.offsetWidth + 60) {
            this.flickity.deactivatePrevNextButtons();
        }
    }
}

angular.module('animatronApp.videoSlider', []).component('videoSlider', {
    bindings: {
        videos: '<'
    },
    controller: VideoSlider,
    templateUrl: require('video-slider.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/videoSlider.ts